import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { DomainProvider } from "@/context/DomainContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";

import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import WorkspaceAccounts from "@/pages/WorkspaceAccounts";
import Users from "@/pages/Users";
import Mailboxes from "@/pages/Mailboxes";
import Groups from "@/pages/Groups";
import OrgUnits from "@/pages/OrgUnits";
import Devices from "@/pages/Devices";
import Migration from "@/pages/Migration";
import Permissions from "@/pages/Permissions";
import Sharing from "@/pages/Sharing";
import Directory from "@/pages/Directory";
import AuditLog from "@/pages/AuditLog";
import Settings from "@/pages/Settings";
import AdminUsers from "@/pages/AdminUsers";

const page = (el, adminOnly) => (
  <ProtectedRoute adminOnly={adminOnly}>
    <Layout>{el}</Layout>
  </ProtectedRoute>
);

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <DomainProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/" element={page(<Dashboard />)} />
              <Route path="/accounts" element={page(<WorkspaceAccounts />)} />
              <Route path="/users" element={page(<Users />)} />
              <Route path="/mailboxes" element={page(<Mailboxes />)} />
              <Route path="/groups" element={page(<Groups />)} />
              <Route path="/org-units" element={page(<OrgUnits />)} />
              <Route path="/devices" element={page(<Devices />)} />
              <Route path="/migration" element={page(<Migration />)} />
              <Route path="/permissions" element={page(<Permissions />)} />
              <Route path="/sharing" element={page(<Sharing />)} />
              <Route path="/directory" element={page(<Directory />)} />
              <Route path="/audit" element={page(<AuditLog />)} />
              <Route path="/settings" element={page(<Settings />)} />
              <Route path="/admins" element={page(<AdminUsers />, true)} />
            </Routes>
          </BrowserRouter>
        </DomainProvider>
      </AuthProvider>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
